function fn_video() {
    $('.video-controls__stop').click(function(){
        $("#video").get(0).pause();

        $('.video-controls__play').removeClass("active");
        $(this).addClass("active");
    });

    $('.video-controls__play').click(function(){
        $("#video").get(0).play();

        $('.video-controls__stop').removeClass("active");
        $(this).addClass("active");
    });

    $('.video-controls__hide').click(function(){
        $('.about_box').toggleClass("closed");
    });
}

$('video').on("click",function(){
    $(this).get(0).play();
});